import React, { memo } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@saleshandy/design-system';
import { DeleteTrashIcon } from '../../../../../../../../shared/svg/delete-trash-icon';
import { formatPhoneNumber } from '../../../../../../helpers/utils/get-formated-numbers';
import type { IProps } from './types';

const DeletePhoneNumberModal: React.FC<IProps> = ({
  show,
  onClose,
  phoneNumber,
  onSubmit,
  isLoading = false,
  isFreeNumber = false,
}) => {
  const handleConfirm = () => {
    onSubmit?.();
  };

  const handleCancel = () => {
    onClose();
  };

  const formattedPhoneNumber = formatPhoneNumber(
    phoneNumber.phoneNumber,
    phoneNumber.isoCountry,
  );
  const numberType =
    phoneNumber.friendlyName || phoneNumber.numberType || 'Number';
  const numberTypeLabel = numberType ? `(${numberType})` : '';

  const title = (
    <div className="d-flex align-items-center gap-10">
      <DeleteTrashIcon className="delete-phone-number-modal__trash-icon" />
      <span className="line-height-1">
        Are you sure you want to delete this number?
      </span>
    </div>
  );

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      aria-labelledby="delete-phone-number-modal-title"
      className="delete-phone-number-modal"
      backdrop="static"
      centered
    >
      <Modal.Header className="delete-phone-number-modal__header">
        <Modal.Title
          id="delete-phone-number-modal-title"
          className="delete-phone-number-modal__title"
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="delete-phone-number-modal__body">
        <p className="delete-phone-number-modal__description">
          Once removed,{' '}
          <span className="delete-phone-number-modal__description__phone-number">
            {formattedPhoneNumber}
            {numberTypeLabel}
          </span>{' '}
          will no longer be available for outbound or inbound calls. This action
          cannot be undone.
        </p>
        {isFreeNumber && (
          <p className="delete-phone-number-modal__description">
            <b>Note:</b> This is your free number. After deletion, the slot will
            remain open. When you purchase a new number, one number will be
            assigned to you for free.
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="delete-phone-number-modal__footer">
        <div className="delete-phone-number-modal__footer-actions">
          <Button
            onClick={handleCancel}
            variant="secondary"
            className="delete-phone-number-modal__cancel-btn"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirm}
            className="delete-phone-number-modal__confirm-btn"
            disabled={isLoading}
            isLoading={isLoading}
            loadingText="Deleting"
          >
            Yes
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(DeletePhoneNumberModal);
